import React, { useRef, useState } from "react"
import { Form, Button, Card, Alert } from "react-bootstrap"
import { Container } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { Link, useHistory } from "react-router-dom"
import leadtubLogoBlack from '../assets/logo/leadtubLogoBlack.png'
import Copyright from "./Copyright"
import LoadingLoginScreen from "./LoadingLoginScreen";
import { getUserInfo } from "../services/UserService"


export default function Login() {
    const emailRef = useRef()
    const passwordRef = useRef()
    const { login } = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const history = useHistory()
    const [loadingScreen, setLoadingScreen] = useState(false);

    async function handleSubmit(e) {
        setLoadingScreen(true);
        e.preventDefault();

        try {
            setError("");
            setLoading(true);
            const authenticationIsOk = await login(emailRef.current.value, passwordRef.current.value);


            history.push("/");






            setLoading(false)
        } catch {
            setError("Misslyckat försök");
        }

        setLoading(false);
        setLoadingScreen(false);
    }

    return (

        <Container fluid
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "100vh", minWidth: '100%', backgroundColor: '#414141' }}
        >
            {loadingScreen ?
                <LoadingLoginScreen /> : <React.Fragment />
            }
            <Card>
                <Card.Body>
                    <img style={{
                        display: 'block',
                        marginLeft: "auto",
                        marginRight: "auto"
                    }}
                        alt="Logo" className="text-center mb-4" src={leadtubLogoBlack} />



                    <h4 className="text-center mb-4">Logga in på webbportalen</h4>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleSubmit} className="loginForm">
                        <Form.Group id="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" ref={emailRef} required placeholder="Example@Leadtub.se" />
                        </Form.Group>
                        <Form.Group id="password">
                            <Form.Label>Lösenord</Form.Label>
                            <Form.Control type="password" ref={passwordRef} required placeholder="********" />
                        </Form.Group>
                        <Button disabled={loading} className="w-100" type="submit">
                            Logga In
                        </Button>
                    </Form>
                    <div className="w-100 text-center mt-3">
                        <Link to="/forgot-password"> Glömt lösenord?</Link>
                    </div>

                </Card.Body>
                <Copyright />
            </Card>

        </Container>
    )
}
